/* ==================================================
   Calibre Time — Configurator Core (Variant Pricing)
   Cart = Shopify native form submit
================================================== */

/* ✅ USE WORKER AS IMAGE PROXY (CORS SAFE) */
const R2_BASE =
  "https://calibre-worker.calibre.workers.dev/assets";

/* 🔥 BYPASS SHOPIFY FETCH WRAPPER */
const nativeFetch = window.fetch.bind(window);

/* ----------------------------------
   Variant index contract (LOCKED)
---------------------------------- */
const LOGO_VARIANT_INDEX = {
  "logo__none": 0,
  "logo__slogo": 1,
  "logo__printed": 2,
  "logo__metal": 3
};



/* ----------------------------------
   Build state
---------------------------------- */
const build = {
  case: null,
  case_size: null,
  bezel: null,
  dial: null,
  hands: null,
  second_hand: null,
  subdial_hands: null,
  strap: null,
  logo: "logo__none",
  metal_logo_finish: "silver",
  cyclops: null,
  gmt: false,
  gmt_hand: null,
  case_back: null
};

const isSkeletonDial = (id) => id && (id.toLowerCase().includes('transparent') || id.toLowerCase().includes('skeleton'));



function initConfigurator() {

  if (window.__calibreInitialized) return;
  window.__calibreInitialized = true;

  window.__calibreInitialLoad = true; // Enable immediate mode for setup

  document.querySelector(".configurator")?.classList.add("loading");
  
  // Strictly hide S Logo button to bypass any Liquid caching or CLI syncing delays
  document.querySelectorAll('.option[data-type="logo"]').forEach(btn => {
     if (btn.dataset.id === 'logo__slogo' || btn.textContent.toLowerCase().includes('s logo')) {
        btn.style.setProperty('display', 'none', 'important');
     }
  });

  document.querySelectorAll(".watch-layer").forEach(layer => {
    if (layer.tagName === "IMG" && !layer.getAttribute("src")) {
      layer.style.display = "none";
    }
  });
  const priceEl = document.getElementById("calibre-price");
  const configRoot = document.getElementById("calibre-config-root");
  if (!configRoot) return;
  const IS_OCTAGONAL = configRoot.dataset.isOctagonal === "true";
  const cyclopsAsset = configRoot.dataset.cyclopsAsset || null;
  const LOGO_CENTER_X = parseInt(configRoot.dataset.logoX) || 387;
  const LOGO_CENTER_Y = parseInt(configRoot.dataset.logoY) || 300;
  const currencySymbol = configRoot.dataset.currencySymbol || "₹";
  const currencyCode = configRoot.dataset.currencyCode || "INR";
  const locale = configRoot.dataset.locale || "en-IN";

  function formatPrice(cents, isAddon = false) {
    let value = cents / 100;

    if (isAddon && currencyCode !== 'INR') {
      // Round to the nearest 5 for add-ons to keep the "menu" clean (e.g. $92 -> $90 or $95)
      value = Math.round(value / 5) * 5;
    } else {
      // Use standard rounding for base prices and totals to match Shopify's catalog
      value = Math.round(value);
    }

    return `${currencySymbol}${value.toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`;
  }

  const gmtLayer = document.getElementById("layer-gmt_hand");
  const deliveryText = document.getElementById("calibre-delivery-text");
  if (deliveryText && currencyCode !== "INR") {
    deliveryText.textContent = "Delivery within 3-4 weeks";
  }
  if (gmtLayer) {
    gmtLayer.style.display = "none";
  }


  function resolveVariant() {

    if (isSkeletonDial(build.dial)) {
      // 9th Variant (Index 8) is the Skeleton Base
      activeVariant = variants[8] || variants[0];
      return;
    }

    const logoIndex = LOGO_VARIANT_INDEX[build.logo] ?? 0;


    const gmtOffset = build.gmt ? 4 : 0;

    const index = logoIndex + gmtOffset;

    activeVariant = variants[index] || variants[0];
  }
  let priceAnimationId = null;

  function setPrice(cents) {
    if (!priceEl) return;

    if (priceAnimationId) {
      cancelAnimationFrame(priceAnimationId);
      priceAnimationId = null;
    }

    const start = parseInt(priceEl.dataset.priceCents || cents);
    const end = cents;

    if (start === end) {
      priceEl.textContent = formatPrice(end);
      priceEl.dataset.priceCents = end;
      return;
    }

    const duration = 400;
    const startTime = performance.now();

    function frame(now) {

      const progress = Math.min((now - startTime) / duration, 1);
      const current = Math.floor(start + (end - start) * progress);

      priceEl.textContent = formatPrice(current);
      priceEl.dataset.priceCents = current;

      if (progress < 1) {
        priceAnimationId = requestAnimationFrame(frame);
      } else {
        priceAnimationId = null;
        priceEl.dataset.priceCents = end;

        // trigger bump AFTER animation completes
        priceEl.classList.add("bump");
        setTimeout(() => priceEl.classList.remove("bump"), 200);
      }

    }

    priceAnimationId = requestAnimationFrame(frame);
  }

  if (!configRoot) return;

  const enabled = configRoot.dataset.configuratorEnabled === "true";
  if (!enabled) return;



  let variants = [];

  try {
    console.log("INIT START");

    variants = JSON.parse(configRoot.dataset.variants || "[]");
  } catch {
    console.error("Invalid variants JSON");
  }

  if (!variants.length) {
    console.error("No variants found");
    return;
  }

  let activeVariant = variants[0];
  function updateGMTPriceLabels() {

    const baseIndex = (build.gmt ? 4 : 0) + (LOGO_VARIANT_INDEX[build.logo] ?? 0);
    const baseVariant = variants[baseIndex];

    if (!baseVariant) return;

    const basePrice = baseVariant.price;

    document.querySelectorAll('[data-type="gmt"]').forEach(btn => {

      const id = btn.dataset.id;

      const gmtOffset = id === "gmt__yes" ? 4 : 0;
      const logoIndex = LOGO_VARIANT_INDEX[build.logo] ?? 0;

      const variant = variants[gmtOffset + logoIndex];

      if (!variant) return;

      const diff = variant.price - basePrice;

      const label = btn.querySelector(".gmt-price-note");
      if (!label) return;

      if (diff === 0) {
        label.textContent = "Included In Price";
      } else if (diff > 0) {
        label.textContent = `+ ${formatPrice(diff, true)}`;
      } else {
        label.textContent = `- ${formatPrice(Math.abs(diff), true)}`;
      }

    });
  }
  console.log("VARIANTS:", variants);

  function updateLogoPriceLabels() {

    if (!activeVariant) return;

    const basePrice = activeVariant.price;

    document.querySelectorAll('[data-type="logo"]').forEach(btn => {

      const id = btn.dataset.id;
      const logoIndex = LOGO_VARIANT_INDEX[id];

      if (logoIndex === undefined) return;

      const gmtOffset = build.gmt ? 4 : 0;
      const variant = variants[logoIndex + gmtOffset];

      if (!variant) return;

      const diff = variant.price - basePrice;

      const label = btn.querySelector(".logo-price-note");
      if (!label) return;

      if (diff === 0) {
        label.textContent = "Included in Price";
      } else if (diff > 0) {
        label.textContent = `+ ${formatPrice(diff, true)}`;
      } else {
        label.textContent = `- ${formatPrice(Math.abs(diff), true)}`;
      }

    });
  }




  priceEl.dataset.priceCents = activeVariant.price;


  /* =========================
   LOGO CANVAS INIT
========================= */

  const logoCanvas = document.getElementById("layer-logo");
  let logoCtx = null;

  if (logoCanvas) {
    logoCanvas.width = 800;
    logoCanvas.height = 800;
    logoCtx = logoCanvas.getContext("2d");
  }

  const scaleSlider = document.getElementById("logo-scale-slider");

  if (scaleSlider) {
    scaleSlider.addEventListener("input", function () {

      let rawScale = parseFloat(this.value);

      // Hard clamp
      logoScale = Math.min(Math.max(rawScale, 0.3), 1);

      drawLogo();
    });
  }

  const metalFinishContainer = document.getElementById("metal-finish-selector");
  const metalFinishLabel = document.getElementById("metal-finish-label");
  const metalFinishInput = document.getElementById("metal-finish-input");

  if (metalFinishContainer) {
    metalFinishContainer.querySelectorAll(".metal-swatch").forEach(swatch => {
      swatch.addEventListener("click", function () {
        metalFinishContainer.querySelectorAll(".metal-swatch").forEach(s => s.classList.remove("active"));
        this.classList.add("active");
        const finish = this.dataset.finish || "silver";
        const label = this.dataset.label || "Silver";
        build.metal_logo_finish = finish;
        if (metalFinishLabel) metalFinishLabel.textContent = label;
        if (metalFinishInput) metalFinishInput.value = label;
        drawLogo();
      });
    });
  }

  let logoImage = null;
  let logoScale = 0.5; // default smaller

  function drawLogo() {
    if (!logoCtx || !logoImage) return;

    logoCtx.clearRect(0, 0, 800, 800);

    const CANVAS_SIZE = 800;
    const MAX_LOGO_WIDTH = 130;

    const aspectRatio = logoImage.width / logoImage.height;

    const safeScale = Math.min(Math.max(logoScale, 0.1), 1);

    let width = MAX_LOGO_WIDTH * Math.pow(safeScale, 1.6);
    let height = width / aspectRatio;

    const DIAL_CENTER_X = LOGO_CENTER_X;
    const DIAL_CENTER_Y = LOGO_CENTER_Y;

    const x = DIAL_CENTER_X - width / 2;
    const y = DIAL_CENTER_Y - height / 2;

    logoCtx.drawImage(logoImage, x, y, width, height);

    if (build.logo && build.logo.toLowerCase().includes('metal') && build.metal_logo_finish) {
      logoCtx.save();
      logoCtx.globalCompositeOperation = "source-in";

      const grad = logoCtx.createLinearGradient(x, y, x + width, y + height);
      const finish = build.metal_logo_finish.toLowerCase();

      if (finish === "silver") {
        grad.addColorStop(0, "#ffffff");
        grad.addColorStop(0.35, "#c2c7cc");
        grad.addColorStop(0.65, "#f0f2f5");
        grad.addColorStop(1, "#9aa0a6");
      } else if (finish === "rosegold" || finish === "rose gold") {
        grad.addColorStop(0, "#fce4dc");
        grad.addColorStop(0.35, "#e59882");
        grad.addColorStop(0.65, "#f7d2c4");
        grad.addColorStop(1, "#b36854");
      } else if (finish === "gold") {
        grad.addColorStop(0, "#fff5be");
        grad.addColorStop(0.35, "#d4af37");
        grad.addColorStop(0.65, "#fae37d");
        grad.addColorStop(1, "#997d1e");
      } else if (finish === "black") {
        grad.addColorStop(0, "#555555");
        grad.addColorStop(0.5, "#1f1f1f");
        grad.addColorStop(1, "#0d0d0d");
      } else if (finish === "blue") {
        grad.addColorStop(0, "#6ba4d9");
        grad.addColorStop(0.5, "#1b4f8a");
        grad.addColorStop(1, "#0f2b4c");
      } else if (finish === "red") {
        grad.addColorStop(0, "#d9534f");
        grad.addColorStop(0.5, "#9e1a1a");
        grad.addColorStop(1, "#590d0d");
      } else {
        grad.addColorStop(0, "#ffffff");
        grad.addColorStop(0.5, "#cccccc");
        grad.addColorStop(1, "#999999");
      }

      logoCtx.fillStyle = grad;
      logoCtx.fillRect(x, y, width, height);
      logoCtx.restore();
    }
  }



  function updatePriceUI() {

    if (!activeVariant) return;

    setPrice(activeVariant.price);

    const mobilePrice = document.getElementById("mobile-calibre-price");
    if (mobilePrice) {
      mobilePrice.innerText = formatPrice(activeVariant.price);
    }

  }

  function filterDials(caseType) {
    const allDials = document.querySelectorAll('[data-type="dial"]');

    allDials.forEach(dial => {
      const id = dial.dataset.id.toLowerCase();
      const isChrono = id.includes("chrono");

      const shouldShow =
        caseType === "chrono" ? isChrono : !isChrono;

      dial.style.display = shouldShow ? "block" : "none";

      if (!shouldShow) {
        dial.classList.remove("active");
      }
    });

    const activeDial = document.querySelector(
      '.option[data-type="dial"].active'
    );

    if (!activeDial || activeDial.style.display === "none") {
      const firstVisible = Array.from(allDials).find(
        d => d.style.display !== "none"
      );

      if (firstVisible) firstVisible.click();
    }
  }






  /* ----------------------------------
     OPTION HANDLING
  ---------------------------------- */

  const options = document.querySelectorAll(".option");
  const customUpload = document.getElementById("custom-logo-upload");
  const logoFileInput = document.getElementById("logo-file");
  const uploadStatus = document.getElementById("logo-upload-status");

  let uploadedLogoBase64 = null;
  let uploadedLogoURL = null; // will be set only at cart stage

  const cyclopsLayer = document.getElementById("layer-cyclops");



  function smoothLayerSwap(layer, newSrc, immediate = false) {
    if (!layer) return;

    if (immediate) {
      if (layer instanceof HTMLImageElement) {
        layer.src = newSrc;
      }
      layer.style.opacity = "1";
      layer.style.display = "block";
      return;
    }

    // Keep track of the latest requested source to prevent race conditions
    layer.dataset.targetSrc = newSrc;

    // Preload the new image first so we can swap immediately once it's ready
    const newImg = new Image();
    newImg.crossOrigin = "anonymous";
    newImg.onload = () => {
      // Abort if the user selected something else in the meantime
      if (layer.dataset.targetSrc !== newSrc) return;

      // 1. Create a clone of the current layer (containing the old image)
      const clone = layer.cloneNode(true);
      clone.removeAttribute("id");
      clone.classList.add("layer-fade-clone");
      clone.style.pointerEvents = "none";
      clone.style.transition = "opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)";
      clone.style.opacity = "1";
      // Note: zIndex is deliberately not set on the clone. This preserves the natural
      // DOM stack order, preventing the clone from drawing on top of hands/markers.

      // Insert clone right after the original layer
      layer.parentNode.insertBefore(clone, layer.nextSibling);

      // 2. Update the original layer with the new source underneath
      if (layer instanceof HTMLImageElement) {
        layer.src = newImg.src;
      }

      // 3. Trigger the fade-out on the clone
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          clone.style.opacity = "0";
        });
      });

      // 4. Clean up the clone after the transition completes
      setTimeout(() => {
        clone.remove();
      }, 550);
    };

    newImg.src = newSrc;
  }



  options.forEach(el => {
    const option = el instanceof HTMLElement ? el : null;
    if (!option) return;

    option.addEventListener("click", () => {

      const type = option.dataset.type;
      const id = option.dataset.id;
      if (!type || !id) return;

      const parent = option.parentElement;
      if (parent) {
        parent.querySelectorAll(".option")
          .forEach(o => o.classList.remove("active"));
      }

      option.classList.add("active");

      if (type === "logo") {

        build.logo = id;

        const isCustom = id.toLowerCase().includes("printed") || id.toLowerCase().includes("metal");

        // Reset everything if switching away from custom types
        if (!isCustom) {

          uploadedLogoBase64 = null;

          const logoFileInput = document.getElementById("logo-file");
          if (logoFileInput) logoFileInput.value = "";

          const uploadStatus = document.getElementById("logo-upload-status");
          if (uploadStatus) uploadStatus.innerText = "";

          const previewWrapper = document.getElementById("logo-preview-wrapper");
          if (previewWrapper) previewWrapper.classList.add("hidden");

          const scaleWrapper = document.getElementById("logo-scale-wrapper");
          if (scaleWrapper) scaleWrapper.classList.add("hidden");

          if (logoCtx) {
            logoCtx.clearRect(0, 0, 800, 800);
          }
        }

        resolveVariant();
        updatePriceUI();
        updateGMTPriceLabels();
        updateLogoPriceLabels();

        if (customUpload) {
          customUpload.classList.toggle("is-visible", isCustom);
          customUpload.classList.remove("hidden");
          if (isCustom) {
            // Ensure user sees the upload button immediately
            setTimeout(() => {
              customUpload.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
          }
        }

        const metalFinishSelector = document.getElementById("metal-finish-selector");
        if (metalFinishSelector) {
          const isMetal = id.toLowerCase().includes('metal');
          metalFinishSelector.classList.toggle("is-visible", isMetal);
          metalFinishSelector.classList.remove("hidden");
        }

        const logoSection = option.closest(".config-section");
        const logoContent = logoSection ? logoSection.querySelector(".config-section-content") : null;
        if (logoContent && !logoSection.classList.contains("collapsed")) {
          setTimeout(() => {
            logoContent.style.maxHeight = (logoContent.scrollHeight + 500) + "px";
          }, 60);
        }

        drawLogo();

        return;
      }

      if (type === "gmt") {

        build.gmt = id === "gmt__yes";

        resolveVariant();
        updatePriceUI();
        updateGMTPriceLabels();   // 🔥 ADD THIS
        updateLogoPriceLabels();  // 🔥 AND THIS (important)

        const gmtLayer = document.getElementById("layer-gmt_hand");
        const gmtOptions = document.querySelector(".gmt-hand-options");

        if (build.gmt) {

          // ✅ SHOW GMT HAND OPTIONS
          if (gmtOptions) {
            const sectionContent = gmtOptions.closest(".config-section-content");
            if (sectionContent instanceof HTMLElement) {
              // Pre-allocate generous headroom for the expanding nested element
              const headroom = sectionContent.scrollHeight + gmtOptions.scrollHeight + 100;
              sectionContent.style.maxHeight = headroom + "px";

              setTimeout(() => {
                // Snap outer boundary back to exact final footprint for tight future toggles
                sectionContent.style.maxHeight = sectionContent.scrollHeight + "px";
              }, 400); // 400ms ensures nested animation is completed
            }

            gmtOptions.classList.remove("gmt-hidden");
          }

          // ✅ AUTO SELECT FIRST GMT HAND
          const firstGmtOption = document.querySelector(
            '.option[data-type="gmt_hand"]'
          );

          if (firstGmtOption) firstGmtOption.click();

        } else {

          // ❌ HIDE GMT HAND OPTIONS
          if (gmtOptions) {
            gmtOptions.classList.add("gmt-hidden");

            const sectionContent = gmtOptions.closest(".config-section-content");
            if (sectionContent) {
              setTimeout(() => {
                // Clean up bounds after child finishes collapsing
                sectionContent.style.maxHeight = sectionContent.scrollHeight + "px";
              }, 400);
            }
          }

          // ❌ REMOVE GMT HAND VISUALLY
          if (gmtLayer instanceof HTMLElement) {
            gmtLayer.style.display = "none";
            gmtLayer.removeAttribute("src");
          }

          build.gmt_hand = null;
        }

        return;
      }


      if (type === "cyclops") {

        build.cyclops = id === "cyclops__with";

        if (!(cyclopsLayer instanceof HTMLElement)) return;

        cyclopsLayer.setAttribute("crossorigin", "anonymous");

        if (cyclopsLayer.dataset.timeoutId) {
          clearTimeout(parseInt(cyclopsLayer.dataset.timeoutId));
          cyclopsLayer.removeAttribute("data-timeout-id");
        }

        if (build.cyclops && cyclopsAsset) {
          if (cyclopsLayer instanceof HTMLImageElement) {
            cyclopsLayer.src = `${R2_BASE}/cyclops/${cyclopsAsset}.webp`;
          }
          cyclopsLayer.style.display = "block";
          void cyclopsLayer.offsetWidth; // Force browser reflow to register display: block
          cyclopsLayer.style.opacity = "1";
        } else {
          cyclopsLayer.style.opacity = "0";
          const timeoutId = setTimeout(() => {
            if (!build.cyclops) {
              cyclopsLayer.style.display = "none";
              cyclopsLayer.removeAttribute("src");
            }
          }, 500); // Aligns with the 500ms CSS transition
          cyclopsLayer.dataset.timeoutId = timeoutId.toString();
        }

        return;
      }

      if (type === "case_back") {
        build.case_back = option.dataset.value || option.innerText.trim();
        return;
      }

      build[type] = id;


      if (type === "case") {

        const isChrono = id.toLowerCase().includes("chrono");

        if (IS_OCTAGONAL) {
          const caseType = isChrono ? "chrono" : "normal";
          filterDials(caseType);
        }

        const gmtSection = document.querySelector('[data-section="gmt"]');

        if (gmtSection) {
          if (isChrono) {
            gmtSection.style.display = "none";
            build.gmt = false;
          } else {
            gmtSection.style.display = "block";
          }
        }
      }

      if (type === "dial") {
        const isSkeleton = isSkeletonDial(id);
        const restrictedSections = ['logo', 'gmt', 'cyclops'];

        restrictedSections.forEach(sectionId => {
          const section = document.querySelector(`[data-section="${sectionId}"]`);
          const tab = document.querySelector(`[data-target="${sectionId}"]`);
          if (isSkeleton) {
            section?.style.setProperty('display', 'none', 'important');
            tab?.style.setProperty('display', 'none', 'important');
          } else {
            section?.style.removeProperty('display');
            tab?.style.removeProperty('display');
          }
        });

        if (isSkeleton) {
          // Force state reset for restricted options
          build.logo = 'logo__none';
          build.gmt = false;
          build.cyclops = false;

          // Clear visual layers immediately
          if (logoCtx) logoCtx.clearRect(0, 0, 800, 800);

          const gmtLayer = document.getElementById("layer-gmt_hand");
          if (gmtLayer) {
            gmtLayer.style.display = "none";
            gmtLayer.removeAttribute("src");
          }

          const cyclopsLayer = document.getElementById("layer-cyclops");
          if (cyclopsLayer) {
            cyclopsLayer.style.display = "none";
            cyclopsLayer.removeAttribute("src");
          }

          // Update UI Active states
          document.querySelectorAll('.option[data-type="logo"], .option[data-type="gmt"], .option[data-type="cyclops"]')
            .forEach(opt => opt.classList.remove('active'));

          document.querySelector('.option[data-type="logo"][data-id="logo__none"]')?.classList.add('active');
          document.querySelector('.option[data-type="gmt"][data-id="gmt__no"]')?.classList.add('active');
          document.querySelector('.option[data-type="cyclops"][data-id="cyclops__without"]')?.classList.add('active');

          if (customUpload) customUpload.classList.add("hidden");
        }

        resolveVariant();
        updatePriceUI();
        updateLogoPriceLabels();
        updateGMTPriceLabels();
      }

      const layer = document.getElementById(`layer-${type}`);

      if (layer instanceof HTMLElement) {

        const newSrc = `${R2_BASE}/${type}/${id}.webp`;

        layer.setAttribute("crossorigin", "anonymous");

        if (["case", "bezel", "dial", "hands", "second_hand", "subdial_hands", "strap"].includes(type)) {
          // Use immediate swap during initial load, smooth swap for user interactions
          smoothLayerSwap(layer, newSrc, window.__calibreInitialLoad);
        } else {
          if (layer instanceof HTMLImageElement) {
            layer.src = newSrc;
          }
        }

        layer.style.display = "block";
      }


    });
  });

  build.case_size = null;

  console.log("INITIALISING DEFAULT OPTIONS");
  [
    "case",
    "case_size",
    "bezel",
    "dial",
    "hands",
    "second_hand",
    "subdial_hands",
    "strap",
    "logo",
    "case_back"
  ].forEach(type => {

    const first = document.querySelector(
      `.option[data-type="${type}"]`
    );
    console.log("Clicking:", type, first);
    if (first) first.click();
  });

  window.__calibreInitialLoad = false; // Disable immediate mode after setup

  resolveVariant();           // 🔥 ensure correct base
  updatePriceUI();
  updateLogoPriceLabels();    // 🔥 now correct
  updateGMTPriceLabels();     // 🔥 now correct

  // Trigger loader logic AFTER initial batch starts loading
  initLoader();

  /* initialize cyclops AFTER layers exist */
  const cyclopsWith = document.querySelector(
    '.option[data-type="cyclops"][data-id="cyclops__with"]'
  );

  if (cyclopsWith) {
    setTimeout(() => {
      cyclopsWith.click();
    }, 50);
  }

  updatePriceUI();

  /* =========================
     LOADER CONTROL
  ========================= */
  function initLoader() {
    const loader = document.getElementById("config-loader");
    const layers = document.querySelectorAll(".watch-layer");

    const startTime = Date.now();
    let loaderRemoved = false;

    // The "Premium Feel" minimum duration
    const minWait = 5000;

    // We wait 100ms to ensure any immediate batch-triggered clicks (like cyclops) have set their src
    setTimeout(() => {
      const loadingImages = Array.from(layers).filter(layer =>
        layer instanceof HTMLImageElement && layer.getAttribute("src") && !layer.complete
      );

      let imagesToLoad = loadingImages.length;
      console.log(`Loader: Waiting for ${imagesToLoad} images`);

      const hideLoader = () => {
        if (loaderRemoved) return;
        loaderRemoved = true;
        console.log("Loader: Hiding now");
        loader?.classList.add("loader-hidden");
        document.querySelector(".configurator")?.classList.remove("loading");
      };

      const checkAllLoaded = () => {
        imagesToLoad--;
        if (imagesToLoad <= 0) {
          const elapsed = Date.now() - startTime;
          const remaining = Math.max(0, minWait - elapsed);
          setTimeout(hideLoader, remaining);
        }
      };

      if (imagesToLoad <= 0) {
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(0, minWait - elapsed);
        setTimeout(hideLoader, remaining);
      } else {
        loadingImages.forEach(img => {
          img.addEventListener("load", checkAllLoaded, { once: true });
          img.addEventListener("error", checkAllLoaded, { once: true });
        });

        // Safety exit for extremely slow networks: 30 seconds
        setTimeout(hideLoader, 30000);
      }
    }, 100);
  }

  if (logoFileInput instanceof HTMLInputElement) {
    logoFileInput.addEventListener("change", async function () {
      const file = this.files ? this.files[0] : null;
      if (!file) return;

      if (file.type !== "image/png") {
        alert("Please upload a PNG file only.");
        this.value = "";
        return;
      }

      const uploadStatus = document.getElementById("logo-upload-status");
      const previewWrapper = document.getElementById("logo-preview-wrapper");
      const previewImage = document.getElementById("logo-preview-image");
      const scaleWrapper = document.getElementById("logo-scale-wrapper");

      // IMMEDIATELY reset UI state while processing
      if (uploadStatus) {
        uploadStatus.innerHTML = "Processing...";
        uploadStatus.style.color = "initial";
      }
      if (previewWrapper) previewWrapper.classList.add("hidden");
      if (scaleWrapper) scaleWrapper.classList.add("hidden");
      uploadedLogoBase64 = null;

      const reader = new FileReader();
      reader.onload = function (e) {
        const tempBase64 = e.target.result;

        // Live render setup
        logoImage = new Image();
        logoImage.crossOrigin = "anonymous";

        logoImage.onload = function () {
          // Use naturalWidth/Height for reliability
          const w = logoImage.naturalWidth || logoImage.width;
          const h = logoImage.naturalHeight || logoImage.height;

          if (w < 400 || h < 400) {
            alert(`Please upload a higher resolution logo (minimum 400x400px). Your logo is ${w}x${h}px.`);
            if (uploadStatus) {
              uploadStatus.innerHTML = "<span style='color:red;'>× Resolution too low</span>";
            }
            // Reset file input so user can try again even with same filename
            logoFileInput.value = "";
            return;
          }

          // SUCCESS: Apply to state and UI
          if (typeof tempBase64 === "string") {
            uploadedLogoBase64 = tempBase64;
            if (uploadStatus) {
              uploadStatus.innerHTML = "✓ Logo ready";
              uploadStatus.style.color = "#86d0cb";
            }

            if (previewWrapper && previewImage instanceof HTMLImageElement) {
              previewImage.src = uploadedLogoBase64;
              previewWrapper.classList.remove("hidden");
            }

            if (scaleWrapper) scaleWrapper.classList.remove("hidden");

            drawLogo();
          }
        };

        logoImage.onerror = function () {
          if (uploadStatus) uploadStatus.innerHTML = "<span style='color:red;'>× Failed to load image</span>";
          logoFileInput.value = "";
        };

        if (typeof tempBase64 === "string") {
          logoImage.src = tempBase64;
        }
      };

      reader.readAsDataURL(file);
    });
  }

  /* const cyclopsWith = document.querySelector(
     '.option[data-type="cyclops"][data-id="cyclops__with"]'
   );
   if (cyclopsWith) cyclopsWith.click();*/

  updatePriceUI();

  /* ----------------------------------
     ADD TO CART (FLATTEN + UPLOAD)
  ---------------------------------- */

  const addToCartBtn =
    document.getElementById("calibre-add-to-cart");

  if (addToCartBtn instanceof HTMLButtonElement) {
    addToCartBtn.addEventListener("click", async () => {
      if (addToCartBtn.classList.contains("processing")) return;

      addToCartBtn.classList.add("processing");
      addToCartBtn.disabled = true;

      if (
        (build.logo === "logo__printed" || build.logo === "logo__metal") &&
        !uploadedLogoBase64
      ) {
        alert("Please upload your logo file before proceeding.");
        if (addToCartBtn instanceof HTMLButtonElement) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove("processing");
        }
        return;
      }
      if (!activeVariant?.id) {
        alert("Variant not selected");
        if (addToCartBtn instanceof HTMLButtonElement) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove("processing");
        }
        return;
      }


      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = "Finalising <span class='spinner'></span>";

      // Upload logo first (only if exists)
      if (
        (build.logo === "logo__printed" || build.logo === "logo__metal") &&
        uploadedLogoBase64
      ) {

        const logoFileName =
          `logos/${Date.now()}-${Math.random().toString(36).substring(2)}.png`;

        const logoResponse = await nativeFetch(
          "https://calibre-worker.calibre.workers.dev/upload",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              fileName: logoFileName,
              fileData: uploadedLogoBase64
            })
          }
        );

        const logoResult = await logoResponse.json();

        if (!logoResult.success) {
          throw new Error("Logo upload failed.");
        }

        uploadedLogoURL = logoResult.url;
      }



      try {

        const canvas = document.createElement("canvas");
        const size = 1080;
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");

        const layers = document.querySelectorAll(".watch-layer");

        layers.forEach(layer => {

          try {

            if (layer.tagName === "CANVAS") {
              ctx.drawImage(layer, 0, 0, size, size);
              return;
            }

            if (layer.tagName === "IMG" && layer.complete && layer.naturalWidth > 0) {
              ctx.drawImage(layer, 0, 0, size, size);
            }

          } catch (err) {
            console.warn("Skipped layer during render:", layer.id);
          }

        });


        const base64 = canvas.toDataURL("image/png");


        const fileName =
          `renders/${Date.now()}-${Math.random().toString(36).substring(2)}.png`;

        /* -----------------------------
           🔁 SAFE UPLOAD WITH RETRY
        ----------------------------- */

        let uploadResult;
        let success = false;
        let attempts = 0;

        while (!success && attempts < 3) {
          attempts++;

          try {
            const response = await nativeFetch(
              "https://calibre-worker.calibre.workers.dev/upload",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  fileName,
                  fileData: base64
                })
              }
            );

            if (!response.ok) {
              throw new Error("HTTP " + response.status);
            }

            const result = await response.json();

            if (result.success) {
              uploadResult = result;
              success = true;
              break;
            }

          } catch (err) {
            if (attempts >= 3) {
              throw new Error("Upload failed after 3 attempts.");
            }
            await new Promise(r => setTimeout(r, 700));
          }
        }

        const renderUrl = uploadResult?.url;

        /* ----------------------------------
           SUBMIT TO CART
        ---------------------------------- */

        const form = document.createElement("form");
        form.method = "POST";
        form.action = "/cart/add";

        const idInput = document.createElement("input");
        idInput.type = "hidden";
        idInput.name = "id";
        idInput.value = activeVariant.id;

        const qtyInput = document.createElement("input");
        qtyInput.type = "hidden";
        qtyInput.name = "quantity";
        qtyInput.value = "1";


        const buildInput = document.createElement("input");
        buildInput.type = "hidden";
        buildInput.name = "properties[_calibre_build]";
        buildInput.value = JSON.stringify({
          configuration: { ...build },
          //custom_logo_file: uploadedLogoURL,
          variant_id: activeVariant.id,
          version: "1.0",
          timestamp: Date.now()
        });

        const readableSpecs = Object.entries(build)
          .filter(([key, value]) => value)
          .map(([key, value]) => {
            const formattedKey =
              key
                .replace(/_/g, " ")
                .replace(/\b\w/g, l => l.toUpperCase());

            const formattedValue =
              value === true
                ? "Yes"
                : String(value)
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, l => l.toUpperCase());

            return `${formattedKey}: ${formattedValue}`;
          })
          .join("\n");


        const specsInput = document.createElement("input");
        specsInput.type = "hidden";
        specsInput.name = "properties[_Specifications]";
        specsInput.value = readableSpecs;

        const renderInput = document.createElement("input");
        renderInput.type = "hidden";
        renderInput.name = "properties[_calibre_render_url]";
        renderInput.value = renderUrl;

        if (uploadedLogoURL) {
          const logoInputField = document.createElement("input");
          logoInputField.type = "hidden";
          logoInputField.name = "properties[_Logo File]";
          logoInputField.value = uploadedLogoURL;
          form.appendChild(logoInputField);
        }

        if (build.logo && build.logo.toLowerCase().includes('metal')) {
          const activeSwatch = document.querySelector("#metal-finish-selector .metal-swatch.active");
          const finishLabel = activeSwatch ? (activeSwatch.dataset.label || "Silver") : "Silver";
          const finishField = document.createElement("input");
          finishField.type = "hidden";
          finishField.name = "properties[Metal Logo Finish]";
          finishField.value = finishLabel;
          form.appendChild(finishField);
        }

        form.appendChild(idInput);
        form.appendChild(qtyInput);
        form.appendChild(buildInput);
        form.appendChild(specsInput);
        form.appendChild(renderInput);

        document.body.appendChild(form);
        // --- SHIP INDIVIDUAL SPECS FOR BETTER CHECKOUT FORMATTING ---
        const individualSpecs = {};
        Object.entries(build).forEach(([key, value]) => {
          if (!value) return;
          if (key === 'metal_logo_finish' && (!build.logo || !build.logo.toLowerCase().includes('metal'))) return;

          const formattedKey = key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
          let formattedValue = value === true ? "Yes" : String(value).replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
          if (key === 'metal_logo_finish') {
            const activeSwatch = document.querySelector("#metal-finish-selector .metal-swatch.active");
            formattedValue = activeSwatch ? (activeSwatch.dataset.label || "Silver") : "Silver";
          }

          // Only add if it's not the logo ID (unless it's an upload)
          if (key !== 'logo') {
            individualSpecs[formattedKey] = formattedValue;
          }
        });

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: activeVariant.id,
            quantity: 1,
            properties: {
              ...individualSpecs,
              _calibre_build: JSON.stringify({
                configuration: { ...build },
                variant_id: activeVariant.id,
                version: "1.0",
                timestamp: Date.now()
              }),
              _Specifications: readableSpecs,
              _calibre_render_url: renderUrl,
              ...(uploadedLogoURL && { "_Logo File": uploadedLogoURL })
            }
          })
        });

        addToCartBtn.innerHTML = "Added ✓";
        addToCartBtn.classList.remove("loading");
        setTimeout(() => {
          window.location.href = "/cart";
        }, 300);

      } catch (err) {

        console.error(err);
        alert("Something went wrong while finalising your watch. Please try again.");

        // Restore button completely
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.classList.remove("processing");
        addToCartBtn.innerHTML = "Add Custom Watch to Cart";

      }

    });
  }
};




let currentMode = null; // "mobile" or "desktop"

function initDesktopAccordion() {
  const sections = document.querySelectorAll(".config-section");

  sections.forEach((section, index) => {
    const toggle = section.querySelector(".config-section-toggle");
    const content = section.querySelector(".config-section-content");

    if (!toggle || !content) return;

    section.classList.remove("mobile-hidden");

    // Start state
    if (index === 0) {
      section.classList.remove("collapsed");

      requestAnimationFrame(() => {
        content.style.maxHeight = content.scrollHeight + "px";
      });
    } else {
      section.classList.add("collapsed");
      content.style.maxHeight = "0px";
    }

    toggle.onclick = () => {
      const isCollapsed = section.classList.contains("collapsed");

      // Close all
      sections.forEach(s => {
        s.classList.add("collapsed");
        const c = s.querySelector(".config-section-content");
        if (c) c.style.maxHeight = "0px";
      });

      // Open clicked
      if (isCollapsed) {
        section.classList.remove("collapsed");
        content.style.maxHeight = (content.scrollHeight + 600) + "px";
      }
    };
  });
}

function initMobileTabs() {
  const tabs = document.querySelectorAll(".mobile-tab");
  const sections = document.querySelectorAll(".config-section");

  function activateSection(target) {
    sections.forEach(section => {
      if (section.dataset.section === target) {
        section.classList.remove("mobile-hidden");
        section.classList.remove("collapsed");

        const content = section.querySelector(".config-section-content");
        if (content) content.style.maxHeight = "none";
      } else {
        section.classList.add("mobile-hidden");
      }
    });

    tabs.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.target === target);
    });
  }

  if (tabs.length) {
    activateSection(tabs[0].dataset.target);
  }

  tabs.forEach(tab => {
    tab.onclick = () => activateSection(tab.dataset.target);
  });

  const scrollContainer = document.getElementById('mobile-tabs-scroll');
  const leftBtn = document.getElementById('mobile-tabs-left');
  const rightBtn = document.getElementById('mobile-tabs-right');

  if (scrollContainer && leftBtn && rightBtn) {
    const updateArrows = () => {
      if (scrollContainer.scrollLeft > 5) leftBtn.classList.remove('hidden');
      else leftBtn.classList.add('hidden');

      if (scrollContainer.scrollLeft < scrollContainer.scrollWidth - scrollContainer.clientWidth - 5) rightBtn.classList.remove('hidden');
      else rightBtn.classList.add('hidden');
    };

    if (!scrollContainer.dataset.arrowsInit) {
      scrollContainer.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      scrollContainer.dataset.arrowsInit = 'true';
    }

    setTimeout(updateArrows, 100);

    leftBtn.onclick = () => scrollContainer.scrollBy({ left: -150, behavior: 'smooth' });
    rightBtn.onclick = () => scrollContainer.scrollBy({ left: 150, behavior: 'smooth' });
  }
}

function handleResponsiveLayout() {
  const isMobile = window.innerWidth <= 900;
  const newMode = isMobile ? "mobile" : "desktop";

  if (newMode === currentMode) return;

  currentMode = newMode;

  if (newMode === "mobile") {
    initMobileTabs();
  } else {
    initDesktopAccordion();
  }

  document.body.classList.toggle("is-mobile", isMobile);
}

document.addEventListener("DOMContentLoaded", () => {
  handleResponsiveLayout();
  window.addEventListener("resize", handleResponsiveLayout);
});

document.addEventListener("DOMContentLoaded", initConfigurator);

document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector("#calibre-config-root")) {
    window.__calibreInitialized = false;
    initConfigurator();
  }
});